import { BaseDataJson } from '@owc-types/BaseDataJSON';
import { Computed } from '@owc-types/ComponentInitializeDispatcher';
// TODO refactor this using the abstract store
import { addFootnotesToStore, mountFootnotes } from '@owc-utils/Footnotes/FootnotesHelper';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';

const mixin: ThisTypedComponentOptionsWithRecordProps<Vue, {}, {}, Computed<BaseDataJson>, {}> = {
  mounted: function() {
    // Triggering footnotes build
    if (this.json && this.json.footnotes) {
      addFootnotesToStore(this.json.footnotes);
    }

    if (this.$el instanceof HTMLElement) {
      this.$nextTick(() => mountFootnotes(this.$el));
    }
  },
};

export default mixin;
